import { TextboxProps } from "@mcleod/components";
import { AbstractComponentDemoExamples } from "./AbstractComponentDemoExamples";

export class DemoTextboxExamples extends AbstractComponentDemoExamples {
    protected override registerExamples() {
        super.registerExamples();
        this.registerLiveDemos({
            name: "Link/Email/Phone Types",
            description: "See how Textboxes that display links, email addresses, and phone numbers can invoke the appropriate action.",
            layoutPath: "component-demo/components/examples/LiveDemoLinkEmailPhone"
        });
        this.registerPropertyExamples("displayType", {
            examples: [
                { value: "date", description: "Setting the displayType to DisplayType.Date adds date validation and a visual date picker" },
            ]
        });
        this.registerPropertyExamples("format", {
            examples: [
                { value: "long", props: { displayType: "date" }, description: "Setting the format to \"long\" with a displayType of DisplayType.DATE will cause the date to display as a full day name, month name, and year." },
            ]
        });
        this.registerPropertyExamples("imagePreName", {
            examples: [
                { value: "person" },
                { value: "circleCheck" },
            ]
        });
        this.registerPropertyExamples("multiline", {
            props: { height: 200, width: 400 },
            examples: [
                { value: true },
            ]
        });
        this.registerPropertyExamples("password", {
            examples: [
                { value: true, description: "Type in this Input and your characters will be masked." },
            ]
        });
        this.registerPropertyExamples("placeholder", {
            examples: [
                { value: "Enter a city/state/zip" },
            ]
        });
        this.registerPropertyExamples("spellcheck", {
            examples: [
                { value: undefined, description: "Note how mispelling something in this Input highlights the misspelling and allows you to correct it." },
                { value: false, description: "Note how this Input doesn't validate spelling." },
            ]
        });
        this.registerPropertyExamples("text", {
            examples: [
                { value: "Initial value" },
            ]
        });
    }

    protected override get propsForAllExamples(): Partial<TextboxProps> {
        return {
            caption: "Sample Textbox"
        };
    }
}
